/**
 *
 * Toolbar
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { sortBy } from 'lodash-es';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import { startOfDay, isSameWeek } from 'utils/date-fns/index.js';
import Navigator from 'components/interaction/Navigator/index.jsx';
import { group } from 'utils/arrays.js';
import BlockTab from './BlockTab.jsx';
import messages from './messages.js';

function Toolbar(props) {
  const { blocks, date, label, onNavigate } = props;
  const dates = blocks && blocks.length > 0 && sortBy(group(blocks, (blk) => startOfDay(blk.start).toJSON()), 'key');

  const navigateTo = (d) => () => onNavigate(navigate.DATE, d);

  const isActive = (dateString) => isSameWeek(new Date(dateString), date);

  const asBlockTab = (d) => {
    const { key, items } = d;
    const newDate = new Date(key);
    return <BlockTab key={key} date={newDate} blocks={items} disabled={isActive(key)} onClick={navigateTo(newDate)} />;
  };

  return (
    <div className="d-flex align-items-center justify-content-between">
      <div>
        {dates
          ? dates.map(asBlockTab)
          : <FormattedMessage {...messages.noSlots} />}
      </div>
      <Navigator label={label} onNavigate={onNavigate} className="mx-4" />
    </div>
  );
}

Toolbar.propTypes = {
  label: PropTypes.string,
  date: PropTypes.object,
  onNavigate: PropTypes.func,
  blocks: PropTypes.array,
};

export default Toolbar;
